module.exports = __webpack_public_path__ + "assets/7ed4a302a0f904f2a65c1ac700a9e120.jpg";